import AWSStorage from "../auth/aws/AWSStorage";
import {P} from "oca-lib-web";
import CacheSettings from "./CacheSettings";

export default class ReportUtil {

    /*
     * Report helpers
     */

    public static getCurrentReportPage(report:any):PageSettings {
        let currentPage = CacheSettings.getCurrentPage();
        let reportPage = this.getReportPage(currentPage, report);
        return reportPage || (report && report.pages && report.pages.length > 0 ? report.pages[0] : null);
    }

    public static getAllReportPages(report:any):Array<any> {
        if (!report || !report.pages) return [];

        let pages = [];
        for (let page of report.pages) {
            pages.push(page);
        }
        return pages;
    }

    public static getReportPage(pageName:String, report:any) {
        if (!report || !report.pages) return null;

        for (let page of report.pages) {
            if (page.id == pageName) {
                return page;
            }
        }
        return null;
    }

    /*
     * Report getter / setter
     */

    public static async getReport(projectId:string):Promise<any> {
        if (!(await this.doesExist(projectId))) {
            return P.resolve({});
        }
        let report = await AWSStorage.getContents("_reports/" + projectId + ".json");
        if (report) {
            let reportObject = JSON.parse(report);
            return P.resolve(reportObject);
        } else {
            return P.resolve({});
        }
    }

    public static async saveReport(projectId:string, report:any):Promise<any> {
        let result = await AWSStorage.put("_reports/" + projectId + ".json", report);
        return P.resolve(result);
    }

    public static async doesExist(projectId:string):Promise<any> {
        let reports = await AWSStorage.list("_reports/");
        for (let report of reports) {
            if (report.key.indexOf(projectId) > -1) {
                return P.resolve(true);
            }
        }
        return P.resolve(false);
    }
}